<template>
  <div>
    <b-button @click="openScheduler" :disabled="!isConnectionOk">
      <font-awesome-icon icon="calendar" />
    </b-button>
    <scheduler-modal ref="schedulerModal" :settings-var="getSingleVar" />
  </div>
</template>

<script>
import SchedulerModal from '@/components/services/service/scheduler/SchedulerModal.vue';
import BaseControlMixin from '@/components/controls/mixins/BaseControl';

export default {
  name: 'SchedulerButton',
  mixins: [
    BaseControlMixin,
  ],
  isInline: true,
  methods: {
    openScheduler() {
      this.$refs.schedulerModal.show();
    },
  },
  components: { SchedulerModal },
};
</script>

<style scoped>

</style>
